/**
 * Lemich Announcement Bar
 * - Rota 3 mensajes cada 4 segundos
 * - Botón X cierra y recuerda en sessionStorage
 */
(function () {
  'use strict';

  const STORAGE_KEY_PREFIX = 'lemich_announcement_dismissed_';
  const ROTATION_MS = 4000;

  function init() {
    const bars = document.querySelectorAll('[data-section-type="announcement-bar"]');
    bars.forEach((bar) => setupBar(bar));
  }

  function setupBar(bar) {
    const sectionId = bar.dataset.sectionId;
    const storageKey = STORAGE_KEY_PREFIX + sectionId;

    // Si ya fue cerrado en esta sesión, ocultar
    if (sessionStorage.getItem(storageKey) === '1') {
      bar.style.display = 'none';
      return;
    }

    const messages = bar.querySelectorAll('.announcement-bar__message');
    const closeBtn = bar.querySelector('[data-close]');

    if (messages.length <= 1) return;

    let currentIndex = 0;
    let timer = null;

    function show(index) {
      messages.forEach((m, i) => {
        m.classList.toggle('is-active', i === index);
      });
    }

    function rotate() {
      currentIndex = (currentIndex + 1) % messages.length;
      show(currentIndex);
    }

    function start() {
      if (timer) clearInterval(timer);
      timer = setInterval(rotate, ROTATION_MS);
    }

    function stop() {
      if (timer) clearInterval(timer);
    }

    // Pausar al hacer hover
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);

    // Botón cerrar
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        stop();
        bar.style.display = 'none';
        try {
          sessionStorage.setItem(storageKey, '1');
        } catch (e) {
          // sessionStorage no disponible — ignorar
        }
        // Avisar al header sticky que recalcule su offset
        window.dispatchEvent(new Event('lemich:announcement-closed'));
      });
    }

    // Iniciar
    show(0);
    // Respetar prefers-reduced-motion: no rotar automáticamente, mostrar solo el primero.
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduced) start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
